import PayItemDeduction from '@/api/hr/pay-item-deduction'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  customRules: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CUSTOM_RULES(state, data) {
    state.customRules = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayItemDeduction.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayItemDeduction.store(data)
  },

  update(context, { id, ...data }) {
    return PayItemDeduction.update(id, data)
  },

  destroy(context, id) {
    return PayItemDeduction.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.deduction_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  async dataBeforeCreate(context) {
    if (!context.state.customRules.length > 0) {
      let response = await PayItemDeduction.customRule()
      context.commit('SET_CUSTOM_RULES', response.data)
    }
  }
}
